import { mapActions, mapState } from "vuex";

export default {
  install(Vue, { store, router, options = {} }) {
    if (!store || !router) {
      return false;
    }

    // 기본 설정과 사용자 설정 병합
    const defaultOptions = {
      defaultCreate: false,
      defaultAutoRedirect: true,
    };
    const pluginOptions = { ...defaultOptions, ...options };
    const actionMethods = mapActions("experimentStore", ["acUserExperiment"]);
    const stateComputed = mapState("experimentStore", ["_experiment"]);
    const actionInstance = new Vue({
      store,
      methods: actionMethods,
      computed: stateComputed,
    });

    Vue.prototype.$experiment = {
      /**
       * A/B 테스트 실행 함수
       * @param {Object} params - 테스트 매개변수
       * @param {string} params.domain - 테스트 도메인 (예: 'client')
       * @param {string} params.type - 테스트 유형 (예: 'amount')
       * @param {boolean} params.create - 실험 그룹 없을 경우 자동 생성 여부
       * @param {boolean} params.autoRedirect - 라우트 정보가 있을 경우 자동 리다이렉트 여부
       * @param {string} params.overwrite - 백엔드에 덮어씌울 실험 그룹 - A,B 등
       * @param {Function} [params.onComponent] - 컴포넌트 반환 시 실행할 콜백
       * @returns {Promise<Object>} 실험 결과 객체
       */
      async run(params) {
        const {
          domain,
          type,
          create = pluginOptions.defaultCreate,
          autoRedirect = pluginOptions.defaultAutoRedirect,
          overwrite = undefined,
        } = params;
        try {
          await actionInstance.acUserExperiment({
            domain,
            type,
            create,
            overwrite,
          });

          const experimentResult = actionInstance._experiment;
          // window.console.log("experimentResult:", experimentResult);

          const result = {
            data: experimentResult,
            isComponent: false,
            componentName: null,
          };

          if (experimentResult?.status === "present") {
            if (experimentResult?.info?.component) {
              result.isComponent = true;
              result.componentName = experimentResult.info.component;
            }
            if (autoRedirect && experimentResult?.info?.route?.length) {
              router.push(experimentResult.info.route);
            }
          }
          return result;
        } catch (error) {
          console.error("오류 발생:", error);
          return null;
        }
      },
    };
  },
};
